import { render, staticRenderFns } from "./MailLogOverview.vue?vue&type=template&id=336faf88&"
import script from "./MailLogOverview.vue?vue&type=script&lang=js&"
export * from "./MailLogOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('336faf88')) {
      api.createRecord('336faf88', component.options)
    } else {
      api.reload('336faf88', component.options)
    }
    module.hot.accept("./MailLogOverview.vue?vue&type=template&id=336faf88&", function () {
      api.rerender('336faf88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/MailLogOverview.vue"
export default component.exports